module.exports = __webpack_public_path__ + "img/markets-reckitt.1d1308b3.jpg";